import { PersonRow } from './PersonRow';
import { Person } from '@/api/types/backend-dto-types';
import EmptyState from '@/components/molecules/EmptyState';
import { cn } from '@/helpers/shadCnUtils';

interface PersonsEditorTableProps {
  persons: Person[];
}

export const PersonsEditorTable = ({ persons }: PersonsEditorTableProps) => {
  return (
    <div className={cn('flex h-full flex-col gap-4 py-1 pr-2')}>
      {persons.length === 0 && (
        <EmptyState title="No entities found" subtitle="Sorry, we couldn't find any entities matching these criteria" />
      )}

      {persons.map((person) => (
        <PersonRow key={person.id} person={person} />
      ))}
    </div>
  );
};
